import React from 'react'
import { Package, QrCode, ArrowsIn, ArrowsOut } from '@phosphor-icons/react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { ELEVATEOS_LOGO_ALT } from '@/constants'

import { APP_COLORS } from '../../helpers/constants'

const Home = ({ onDeliverPackage, onEnterCode, isFullscreen, onToggleFullscreen }) => {
  const { t } = useTranslation(['package-room'])
  return (
    <React.Fragment>
      <div className="package-room__content">
        <h1 className="package-room__title">{t('package-room:home.getStarted')}</h1>

        <div className="package-room__options">
          <button
            className="package-room__option package-room__option--deliver"
            onClick={onDeliverPackage}
          >
            <Package size={80} />
            <span className="package-room__option-text">
              {t('package-room:home.deliverYourPackage')}
            </span>
          </button>

          <button className="package-room__option package-room__option--code" onClick={onEnterCode}>
            <QrCode size={80} />
            <span className="package-room__option-text">
              {t('package-room:home.pickupPackage')}
            </span>
          </button>
        </div>

        <div className="package-room__brand">
          <img
            src="/images/logo/elevateos-logo-wide-black.svg"
            alt={ELEVATEOS_LOGO_ALT}
            className="package-room__brand-logo"
          />
        </div>
      </div>
      <img
        src="/images/package-room/background.png"
        alt={t('package-room:home.packageRoomAlt')}
        className="package-room__photo"
      />

      <button
        className="package-room__fullscreen-button"
        onClick={onToggleFullscreen}
        aria-label={
          isFullscreen
            ? t('package-room:home.exitFullscreen')
            : t('package-room:home.enterFullscreen')
        }
      >
        {isFullscreen ? (
          <ArrowsIn size={24} color={APP_COLORS.primary} weight="bold" />
        ) : (
          <ArrowsOut size={24} color={APP_COLORS.primary} weight="bold" />
        )}
      </button>
    </React.Fragment>
  )
}

Home.propTypes = {
  onDeliverPackage: PropTypes.func.isRequired,
  onEnterCode: PropTypes.func.isRequired,
  isFullscreen: PropTypes.bool.isRequired,
  onToggleFullscreen: PropTypes.func.isRequired,
}

export default Home
